









































































































































import { Vue,Component } from 'vue-property-decorator'
import { State,Action,Mutation,namespace } from 'vuex-class'
import exicon from '../../assets/js/expressicon.ts'
import ImportBranch from '../../components/common/importBranch.vue'
import region from '../../assets/js/region.ts'
const user = namespace('user')
@Component({
    components: {
        ImportBranch
    }
})
export default class Partner extends Vue{
    excomIcon:string = '' //当前选择的快递公司图标
    exicon:any = exicon
    search:any = {
        site: '',
        name: '',
        phone: '',
        excom: '',
        page: 1
    }
    dialogVisible:boolean = false
    modifyIndex:number = 0 //修改的快递单价的下标
    modifyId:string = '' //修改的快递ID
    modifyPrice:number = 0 //修改的快递单价
    partnerInfo:Boolean = false //查看日志弹窗
    partnerDetail = null //快递员详情
    minimumDialog:boolean = false //设置低价弹窗
    minimumList: any[] = [{
        region: [],
        fprice: 0,
        sprice: 0,
        fweight: 1
    }]
    rechargeDialog:boolean = false // 快递员充值弹窗
    rechargeForm:any = {
        amount:'',
        present:'',
        desc:''
    }
    rechargeId:string = '' //快递员充值id
    @user.State('excom') excom:any //快递公司列表
    @user.State('partnerPager') partnerPager:any //表格的页码
    @user.State('partnerList') partnerList:any //用户列表
    @user.State('loading') loading:any

    get tablecolumn(){
        return [
            {
                prop: 'name',
                name: 'name',
                type: 'slot',
                label: '快递员姓名',
            },
            {
                prop: 'phone',
                type: 'text',
                label: '电话',
            },
            {
                prop: 'price',
                type: 'text',
                label: '单价',
            },
            {
                prop: 'money',
                type: 'text',
                label: '余额',
                color: '#409eff'
            },
            {
                prop: 'excom',
                name: 'excom',
                type: 'slot',
                label: '快递公司',
            },
            {
                prop: 'ctime',
                type: 'text',
                label: '创建时间',
            },
            {
                prop: 'status',
                name: 'status',
                type: 'slot',
                label: '状态',
            },
            {
                prop: 'desc',
                type: 'text',
                label: '备注',
            },
            {
                prop: 'operation',
                name:'operation',
                type: 'slot',
                label: '操作'
            }
        ]
    }
    // 导数据
    get importBranchColumn(){
        return [
            {
                prop: 'region',
                type: 'select',
                label: '省份或者特殊区域',
              options: region,
                optionsLabel: 'name',
                optionsValue: 'name',
                multiple: true
            },
            {
                prop: 'fprice',
                type: 'InputNumber',
                min: 0,
                label: '首重价格',
            },
            {
                prop: 'sprice',
                type: 'InputNumber',
                min: 0,
                label: '续重价格',
            },
            {
                prop: 'fweight',
                type: 'InputNumber',
                min: 1,
                label: '首重重量',
            },
            {
                name: 'operation',
                type: 'slot',
                label: '操作',
            }
        ]
    }
    @user.Mutation('changeList') changeList:any
    @user.Action('getExcom') getExcom:any //获取快递公司
    @user.Action('getPartnerList') getPartnerList:any
    @user.Action('modifyPartnerPrice') modifyPartnerPrice:any //修改快递员单价
    @user.Action('deletePartner') deletePartner:any //修改快递员单价
    @user.Action("getPartnerDetail") getPartnerDetail:any
    @user.Action("addMinimumPartner") addMinimumPartner:any
    @user.Action('importPartnerFun') importPartnerFun:any
    @user.Action('partnerRecharge') partnerRecharge:any

    mounted(){
        this.getExcom()
        this.getList()
    }
    getList(){
        this.getPartnerList(this.search)
    }
    excomChange(e:any){
        if(e){
            this.excom.map((item:any)=>{
                if(item._id == e){
                    this.excomIcon = item.pinyin
                }
            })
        }else{
            this.excomIcon = ''
        }
    }
    // 快递员列表操作按钮
    dropmenu(e:any){
        console.log(e.val);
        if(e.com == 'modifyPrice'){
            this.openModify(e.val._id,e.val.price,e.val.index)
        }else if(e.com == 'delete'){
            this.deletePartnerFun(e.val._id)
        }else if(e.com == 'add'){
            this.showMinimumDialog(e.val._id)
        }
        // else{
        //     this.againSendSmsFun()
        // }
    }
    openModify(id:string,price:number,index:number){
        this.modifyId = id
        this.dialogVisible = true
        this.modifyPrice = price
        this.modifyIndex = index
    }
    async modifyPriceFun(index:number){
        const res = await this.modifyPartnerPrice({
            id: this.modifyId,
            data: {
                price: this.modifyPrice
            }
        })
        if(res){
            this.$message({message: '修改成功', type: 'success'});
            this.changeList({
                index: this.modifyIndex,
                val: this.modifyPrice
            })
            this.dialogVisible = false
        }
    }
    async deletePartnerFun(id:string){
        this.$confirm('确定删除吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async() => {
            const res = await this.deletePartner(id)
            if(res){
                this.$message({message: '删除成功', type: 'success'});
                this.getList()
            }
        }).catch(() => {});

    }
    // 充值
    openRecharge(id:string){
        this.rechargeDialog = true;
        this.rechargeId = id;
    }
    // 充值
    async recharge(){
        await this.partnerRecharge({
            id: this.rechargeId,
            data: this.rechargeForm
        })
        this.$message({  message: '充值成功',type: 'success' });
        this.rechargeDialog = false
        this.getList()
    }
    // 网点改变的时候
    changeSite(val:string){
        this.search.site = val
        this.getList()
    }
    // 查看快递员详情
    async lookInfo(id:string){
        const res = await this.getPartnerDetail(id)
        if(res){
            this.partnerDetail = res
            this.partnerInfo = true;
        }
    }
    async showMinimumDialog(id:string){
        const res = await this.getPartnerDetail(id)
        if(res){
            this.minimumList = res.sale
        }
        this.modifyId = id
        this.minimumDialog = true
    }
    hideMinimum(){
        this.minimumDialog = false
    }
    // 添加底价行数
    async addMinimumList(){
        const status = await this.checkInfo()
        if(status){
            this.minimumList.push({
                region: [],
                fprice: 0,
                sprice: 0,
                fweight: 1
            })
        }else{
            this.$message({  message: '请先将信息填写完成', type: 'warning' });
        }
    }
    // 删除一行
    deleteMinimumList(index:number){
        console.log(index);
        this.minimumList.splice(index,1)
    }
    // 检查信息是否填写完整
    checkInfo(){
        let status = true
        this.minimumList.forEach(item => {
            if(item.region.length < 1 || item.fprice == 0 || item.sprice == 0 ){
                status = false
                return
            }
        });
        return status
    }
    // 添加底价
    async addMinimum(){
        const status = await this.checkInfo()
        if(status){
            const res = await this.addMinimumPartner({
                id: this.modifyId,
                data: {sale:this.minimumList}
            })
            if(res){
                this.$message({  message: '添加成功', type: 'success' });
                this.minimumDialog = false
            }
        }else{
            this.$message({  message: '请先将信息填写完成', type: 'warning' });
        }
    }
    // 导入快递员
    async importPartner(){
        await this.importPartnerFun({
            site: this.search.site
        })
        this.getList()
    }
    // 改变页码
    pagechange(e:any){
        this.search.page = e[0].val;
        this.getList()
    }
}
